import api from './api';

// Locales editable from the course forms. 'en' is stored on the base
// courses table; the rest go to course_translations.
export const CONTENT_LOCALES = [
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'fr', label: 'Français', dir: 'ltr' },
  { code: 'ar', label: 'العربية', dir: 'rtl' },
];

export const TRANSLATABLE_LOCALES = CONTENT_LOCALES.filter((l) => l.code !== 'en').map(
  (l) => l.code
);

export const localeDir = (code) =>
  CONTENT_LOCALES.find((l) => l.code === code)?.dir || 'ltr';

export const makeEmptyTranslations = () =>
  TRANSLATABLE_LOCALES.reduce((acc, code) => {
    acc[code] = { title: '', description: '' };
    return acc;
  }, {});

export const hasContent = (fields) =>
  Object.values(fields || {}).some((v) => v && v.trim() !== '');

// Fetch existing translations for a course, shaped for the form state.
// Returns { translations, loadedLocales } — loadedLocales tracks which rows
// already exist so clearing a tab still saves (clears) that row.
export const fetchCourseTranslations = async (courseId) => {
  const translations = makeEmptyTranslations();
  const loadedLocales = [];
  const res = await api.get(`/courses/${courseId}/translations`);
  (res.data || []).forEach((row) => {
    if (!translations[row.locale]) return;
    translations[row.locale] = {
      title: row.title || '',
      description: row.description || '',
    };
    if (hasContent(translations[row.locale])) loadedLocales.push(row.locale);
  });
  return { translations, loadedLocales };
};

// Upsert non-English translations. Skips locales that are empty and were
// never saved; empty fields are sent as null so display falls back to English.
export const saveCourseTranslations = async (courseId, translations, loadedLocales = []) => {
  for (const locale of TRANSLATABLE_LOCALES) {
    const fields = translations[locale];
    if (!hasContent(fields) && !loadedLocales.includes(locale)) continue;
    await api.put(`/courses/${courseId}/translations/${locale}`, {
      title: fields.title.trim() || null,
      description: fields.description.trim() || null,
    });
  }
};
